import {
  ISelectionState,
  ITaxonomyCategorizedData,
} from "../TaxonomyTags.types";

const updateChildrenSelection = (
  parentId: string,
  selected: boolean,
  categorizedData: ITaxonomyCategorizedData,
  newState: ISelectionState,
) => {
  for (const levelKey in categorizedData) {
    const items = categorizedData[levelKey];
    items?.forEach((item) => {
      if (item.parentId === parentId) {
        if (!newState[item.id]) {
          newState[item.id] = { selected };
        } else {
          newState[item.id] = {
            ...(newState[item.id] as ISelectionState),
            selected,
          };
        }
        updateChildrenSelection(item.id, selected, categorizedData, newState);
      }
    });
  }
};

const updateParentsSelection = (
  state: ISelectionState,
  itemId: string,
  categorizedData: ITaxonomyCategorizedData,
): ISelectionState => {
  const newState = { ...state };

  const item = Object.values(categorizedData)
    .flat()
    .find((item) => item.id === itemId);

  if (item?.parentId) {
    const parent = Object.values(categorizedData)
      .flat()
      .find((parentItem) => parentItem.id === item.parentId);
    if (parent) {
      const children = Object.values(categorizedData)
        .flat()
        .filter((childItem) => childItem.parentId === parent.id);
      const allSelected = children.every((child) =>
        isSelected(newState, child.id),
      );
      const someSelected = children.some(
        (child) =>
          isSelected(newState, child.id) ||
          (newState[child.id] &&
            (newState[child.id] as ISelectionState).isSemiSelected),
      );

      if (allSelected) {
        newState[parent.id] = { selected: true, isSemiSelected: false };
      } else if (someSelected) {
        newState[parent.id] = { selected: false, isSemiSelected: true };
      } else {
        newState[parent.id] = { selected: false, isSemiSelected: false };
      }

      return updateParentsSelection(newState, parent.id, categorizedData);
    }
  }

  return newState;
};

export const updateSelectionState = (
  state: ISelectionState,
  id: string,
  selected: boolean,
  categorizedData: ITaxonomyCategorizedData,
): ISelectionState => {
  const newState: ISelectionState = { ...state };

  if (!newState[id]) {
    newState[id] = { selected };
  } else {
    newState[id] = { ...(newState[id] as ISelectionState), selected };
  }

  updateChildrenSelection(id, selected, categorizedData, newState);

  const updatedState = updateParentsSelection(newState, id, categorizedData);

  if (selected && (updatedState[id] as ISelectionState).isSemiSelected) {
    delete (updatedState[id] as ISelectionState).isSemiSelected;
    updateChildrenSelection(id, true, categorizedData, updatedState);
  }

  return updatedState;
};

export const isSelected = (state: ISelectionState, id: string): boolean => {
  return !!(state[id] && (state[id] as ISelectionState).selected);
};

export const isSemiSelected = (state: ISelectionState, id: string): boolean => {
  return !!(state[id] && (state[id] as ISelectionState).isSemiSelected);
};
